import React from 'react'
import { CircularProgress } from '@mui/material'


type Props = {}

const BigLoader = (props: Props) => {
    return (
        <div className="w-full flex justify-center items-center py-5">
            <CircularProgress
                style={{ color: "#2E6A73" }}
            />
        </div>
    )
}

export default BigLoader